import apiRequestV2, {baseApiV2Path} from "./api";

export const getBusinessTypes = (username, token, formName) =>
    apiRequestV2('get', `${baseApiV2Path}/onboarding/getbusinesstypes`, {
        queryStringParameters: { formName },
    });